import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// Get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('customerToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Favorites
export const addFavorite = async (venueId, notes = '') => {
  const response = await axios.post(
    `${BACKEND_URL}/api/favorites`,
    { venueId, notes },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const getFavorites = async () => {
  const response = await axios.get(`${BACKEND_URL}/api/favorites`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const removeFavorite = async (favoriteId) => {
  const response = await axios.delete(
    `${BACKEND_URL}/api/favorites/${favoriteId}`,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

// Inquiries
export const getCustomerInquiries = async () => {
  const response = await axios.get(`${BACKEND_URL}/api/customers/inquiries`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Contracts
export const getCustomerContracts = async () => {
  const response = await axios.get(`${BACKEND_URL}/api/customers/my-contracts`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const approveContract = async (reservationId) => {
  const response = await axios.post(
    `${BACKEND_URL}/api/customers/contracts/${reservationId}/approve`,
    {},
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const rejectContract = async (reservationId) => {
  const response = await axios.post(
    `${BACKEND_URL}/api/customers/contracts/${reservationId}/reject`,
    {},
    { headers: getAuthHeaders() }
  );
  return response.data;
};

// Invitations
export const createInvitation = async (invitationData) => {
  const response = await axios.post(
    `${BACKEND_URL}/api/invitations`,
    invitationData,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const getMyInvitations = async () => {
  const response = await axios.get(`${BACKEND_URL}/api/customers/my-invitations`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const getPublicInvitation = async (invitationId) => {
  const response = await axios.get(`${BACKEND_URL}/api/invitations/public/${invitationId}`);
  return response.data;
};

export const deleteInvitation = async (invitationId) => {
  const response = await axios.delete(
    `${BACKEND_URL}/api/customers/invitations/${invitationId}`,
    { headers: getAuthHeaders() }
  );
  return response.data;
};


// ============================================
// VENUE VISITS (RANDEVU) APIs
// ============================================

// Send SMS verification code for venue visit
export const sendVisitVerificationCode = async (data) => {
  const response = await axios.post(
    `${BACKEND_URL}/api/venue-visits/send-code`,
    data
  );
  return response.data;
};

// Verify SMS code and create venue visit request
export const verifyAndCreateVisit = async (data) => {
  const response = await axios.post(
    `${BACKEND_URL}/api/venue-visits/verify-and-create`,
    data
  );
  return response.data;
};

// Create venue visit request (logged in customer)
export const createVenueVisit = async (visitData) => {
  const response = await axios.post(
    `${BACKEND_URL}/api/venue-visits`,
    visitData,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

// Get customer's venue visits
export const getMyVenueVisits = async () => {
  const response = await axios.get(
    `${BACKEND_URL}/api/venue-visits`,
    { headers: getAuthHeaders() }
  );
  return response.data;
};
